<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title">{{$t('label_119')}}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 90px ">
                      <p>{{$t('label_133')}}</p>
                    </div>
                    <div class="select">
                      <el-input v-model="searchDataList.code" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" >
                    <div class="selectText" style="width: 90px ">
                      <p>{{$t('label_129')}}</p>
                    </div>
                    <div class="select">
                      <el-input v-model="searchDataList.model" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 90px ">
                      <p>{{$t('label_664')}}</p>
                    </div>
                    <div class="select">
                      <el-input v-model="searchDataList.name" clearable></el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" :style="{'height':'calc(100% - 150px)'}">
              <!--button按钮-->
              <div class="buttonBox" style="margin-bottom: 10px;">
                <div>
                  <div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('134')>=0">
                    <i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
                  </div>
                  <div class="chooseButton searchButton" @click="addFactory($t('btn_15'))" v-if="MenuRoleList.indexOf('135')>=0">
                    <i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
                  </div>
                  <div class="chooseButton deleteButton" @click="factoryDel" v-if="MenuRoleList.indexOf('136')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
<!--                  <div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('137')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
<!--                   <div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('134')>=0"><i class="el-icon-upload2"></i>导入</div> -->
                </div>
              </div>

              <!--table头部-->
              <div class="tableMin" >
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
                  @current-change="handleCurrentChangeTree" border style="width: 100%;" height="100%"
                  :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
                    width="50" prop="id">
                  </el-table-column>
                  <el-table-column prop="code" :label="$t('label_124')" align="left">
                  </el-table-column>
                  <el-table-column prop="model" :label="$t('label_129')" align="left">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_664')" align="left">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_672')" align="left">
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="saler" :label="$t('label_235')" align="left">
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.saler" :hoverMes="scope.row.saler" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" :label="$t('label_239')" align="left">
                    <template slot-scope="scope">
                      {{scope.row.price}} {{$t('label_870')}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="typeName" :label="$t('label_243')" align="left ">
                    <template slot-scope="scope">
                      {{scope.row.typeName}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="warningInventory" :label="$t('label_246')" align="left">
                    <template slot-scope="scope">
                      {{scope.row.warningInventory}} {{scope.row.unit}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="warningTime" :label="$t('label_249')" align="left">
                    <template slot-scope="scope">
                      {{scope.row.warningTime}} {{$t('label_534')}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_252')" align="left">
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div style="position: absolute;bottom: 30px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
                    :currentspage="1" @parentMethod="searchPage"></Page>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--弹框-->
    <el-dialog v-loading="saveLoading" :title="factoryDialogTitle" :visible.sync="dialogFactory" append-to-body :close-on-click-modal='false'
      width="900px" top="10%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000">*</span>{{$t('label_124')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-input maxlength="200" show- word-limit v-model="dialogFactoryEdit.code" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 50px">
            <p><span style="color: #ff0000">*</span>{{$t('label_664')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-input v-if="factoryDialogTitle == $t('btn_14')" v-model="dialogFactoryEdit.name" clearable></el-input>
              <el-input v-if="factoryDialogTitle == $t('btn_15')" v-model="dialogFactoryEdit.name" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000">*</span>{{$t('label_129')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-input maxlength="200" v-model="dialogFactoryEdit.model" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 50px">
            <div class="selectText">
              <p><span style="color: #ff0000">*</span>{{$t('label_672')}}</p>
            </div>
            <div class="select" style="width: 200px">
              <el-autocomplete style="width: 100%" v-model="dialogFactoryEdit.maker" :fetch-suggestions="querySearchAsync"
                value-key="name" clearable></el-autocomplete>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="selectText">
            <p><span style="color: #ff0000">*</span>{{$t('label_235')}}</p>
          </div>
          <div class="select" style="width: 200px">
            <el-autocomplete style="width: 100%" v-model="dialogFactoryEdit.saler" :fetch-suggestions="querySearchAsync"
              value-key="name" clearable></el-autocomplete>
          </div>
          <div class="dialogMes" style="margin-left: 50px">
            <p><span style="color: #ff0000">*</span>{{$t('label_239')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-input maxlength="200" v-model="dialogFactoryEdit.price" clearable>
                <!-- <i slot="suffix" style="font-style: normal; margin-right: 10px; line-height: 36px">{{$t('label_870')}}</i> -->
              </el-input>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000">*</span>{{$t('label_243')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-select v-model="dialogFactoryEdit.type" style="width:200px">
                <el-option v-for="(item,index) in typedown" :label="item.val" :value="item.key" :key="item.key"
                  :clearable="false">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 50px">
            <p>{{$t('label_249')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-input v-model="dialogFactoryEdit.warningTime" clearable>
                <i slot="suffix" style="font-style: normal; margin-right: 10px">{{$t('label_534')}}</i>
              </el-input>
            </div>
          </div>
        </div>
        <div class="dialogMes">
		  <div class="dialogMes">
		    <p>{{$t('label_246')}}</p>
		    <div class="mesInput" style="width: 200px">
		      <el-input maxlength="200" v-model="dialogFactoryEdit.warningInventory" clearable></el-input>
		    </div>
		  </div>
          <div class="dialogMes" style="margin-left: 50px">
            <p><span style="color: #ff0000">*</span>{{$t('label_670')}}</p>
            <div class="mesInput" style="width: 200px">
              <el-select v-model="dialogFactoryEdit.unit" style="width:200px">
                <el-option v-for="(item,index) in unitdown" :label="item.val" :value="item.val" :key="item.val">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="dialogMes" style="margin-top: 10px">
          <p>{{$t('label_252')}}</p>
          <div class="mesInput" style="width: 550px">
            <el-input type="textarea" :placeholder="$t('input_46')" maxlength="100" show-word-limit
              v-model="dialogFactoryEdit.remark" clearable></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="buttonBox" style="justify-content: center">
          <div class="chooseButton sendButton" @click="FactoryEditSave(factoryDialogTitle)">{{$t('btn_13')}}</div>
          <div class="chooseButton searchButton" style="width: 150px" @click="handleClose">{{$t('btn_1')}}</div>
        </span>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList"
      style="width: 100%;height: 100%" ref="exportBox"></exportMes>
  </div>
</template>


<script>
  import "@/assets/css/map/map.css"
  import "@/assets/css/common/spot.css"
  import Page from "@/components/common/page";
  import TimePage from "@/assets/js/timePage/timePage.js";
  import utils from '@/utils/utils'
  import calendar from "@/components/list/calendar/calendar";
  import file from "@/assets/js/file/file.js";
  import exportMes from "@/components/list/export/export";
  import popMesBox from "@/components/list/popover/pop";

  export default {
    name: 'partInfo',
    components: {
      Page,
      calendar,
      exportMes,
      popMesBox,
    },
    data() {
      return {
        saveLoading: false,
        pageNum: 1,
        select: 0,
        pageSize: 10,
        pageCount: 0,
        Readytime: '',
        height: 620,
        MenuRoleList: [],
        exportTitle: this.$t('label_119'),
        exportList: [{
          column: 'code',
          title: this.$t('label_124'),
          headerAlign: 'center',
          align: 'center',
          width: '50px'
        }, {
          column: 'name',
          title: this.$t('label_664'),
          headerAlign: 'center',
          align: 'center',
          width: '50px'
        }, {
          column: 'model',
          title: this.$t('label_129'),
          headerAlign: 'center',
          align: 'center',
          width: '80px'
        }, {
          column: 'maker',
          title: this.$t('label_672'),
          headerAlign: 'center',
          align: 'center',
          width: '100px'
        }, {
          column: 'saler',
          title: this.$t('label_235'),
          headerAlign: 'center',
          align: 'center',
          width: '100px'
        }, {
          column: 'price',
          title: this.$t('label_262'),
          headerAlign: 'center',
          align: 'center',
          width: '50px'
        }, {
          column: 'typeName',
          title: this.$t('label_243'),
          headerAlign: 'center',
          align: 'center',
          width: '30px'
        }, {
          column: 'warningInventory',
          title: this.$t('label_246'),
          headerAlign: 'center',
          align: 'center',
          width: '50px',
        }, {
          column: 'unit',
          title: this.$t('label_670'),
          headerAlign: 'center',
          align: 'center',
          width: '30px'
        }, {
          column: 'warningTime',
          title: this.$t('label_266'),
          headerAlign: 'center',
          align: 'center',
          width: '50px'
        }, {
          column: 'remark',
          title: this.$t('label_252'),
          headerAlign: 'center',
          align: 'center',
        }],
        dialogFactoryEdit: {
          code: "",
          name: "",
          maker: "",
          model: "",
          saler: "",
          price: "",
          type: this.defaultType,
          unit: this.defaultUnit,
          warningInventory: "",
          warningTime: "",
          remark: "",
        },
        cardData: [],
        tableDataTreeInfo: {}, //页面数据
        factoryDialogTitle: this.$t('btn_14'), //弹出框的标题
        getTreeMes: '1',
        dialogFactory: false, //弹出框的当前状态
        searchDataList: {
          list: [],
          name: '',
          language: 'zh',
        },
        tableDataTreeTime: [],
        tableDataTreeTimeExport: [], //页面导出的数据
        tableDataTree: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        unitdown: [],
        typedown: [],
        defaultType: 0,
        defaultUnit: 0,
      }
    },
    methods: {
      search() {
        let param = {
          pageNum: 1,
          pageSize: this.pageSize
        }
        this.searchPage(param);
      },
      //分页查询
      searchPage(param) {
        var dataParam = this.searchDataList;
        var newParam = Object.assign(param, dataParam);
        this.pageNum = newParam.pageNum;
        this.pageSize = newParam.pageSize;
        this.getPartsinformation(newParam);
        this.exportEquipmentParts(newParam);
      },

      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      exportClick() {
        this.$refs.exportBox.setExportExcel();
      },
      selectProp: function(index) {
        console.log(index)
        this.select = index
      },

      //备件信息 分页接口
      getPartsinformation(param) {
        file.getPartsinformation(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            // console.log(data)
            this.tableDataTreeTime = data.data.records;
            this.pageCount = data.data.total;
            this.pageSize = data.data.size;
            this.pageNum = data.data.current;
            this.$refs['pageModel'].setCurrent(this.pageNum);
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      //导出数据
      exportEquipmentParts(param) {
        file.exportEquipmentParts(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataTreeTimeExport = data.data;
            for (let i = 0; i < this.tableDataTreeTimeExport.length; i++) {
              //this.tableDataTreeTimeExport[i].type='电器' ;
            }
          }
        }).catch((response) => {
          console.log(response)
        })
      },

      //单位下拉选
      getUnitdown() {
        file.getByDictIdALL({dictId: 4, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          //console.log(response.data)
          const data = response.data;
          if (data.code == "1") {
            this.unitdown = data.data;
            this.defaultUnit = data.data[0].val
            this.dialogFactoryEdit.unit = this.defaultUnit
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getUnitdown(4).then((response) => {
        //   //console.log(response.data)
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.unitdown = data.data;
        //     this.defaultUnit = data.data[0].val
        //     this.dialogFactoryEdit.unit = this.defaultUnit
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
      },
      //分类下拉选
      getTypedown() {
        file.getByDictIdALL({dictId: 3, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.typedown = data.data;
            for (let i = 0; i < this.typedown.length; i++) {
              this.typedown[i].key = Number(this.typedown[i].key);
            }
            this.defaultType = data.data[0].key
            this.dialogFactoryEdit.type = this.defaultType
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getTypedown(3).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.typedown = data.data;
        //     for (let i = 0; i < this.typedown.length; i++) {
        //       this.typedown[i].key = Number(this.typedown[i].key);
        //     }
        //     this.defaultType = data.data[0].key
        //     this.dialogFactoryEdit.type = this.defaultType
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
      },

      //点击编辑选中的数据
      addFactory(title) {
        this.factoryDialogTitle = title;
        if (title != this.$t('btn_14')) {
          if (Object.keys(this.tableDataTreeInfo).length > 0) {
            this.dialogFactory = true;
            this.dialogFactoryEdit = this.tableDataTreeInfo;
            file.saveEquipmentPartsInfoByid(this.tableDataTreeInfo.id).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.dialogFactory = true;
                this.dialogFactoryEdit = data.data
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          } else {
            utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
          }
        } else {
          this.dialogFactory = true;
        }
      },
      //弹框关闭再打开清空的方法
      handleClose() {
        this.dialogFactory = false;
        this.dialogFactoryEdit = {
          code: "",
          name: "",
          maker: "",
          model: "",
          saler: "",
          price: "",
          type: this.defaultType,
          unit: this.defaultUnit,
          warningInventory: "",
          warningTime: "",
          remark: ""
        }
      },


      handleCurrentChangeTree(info) {
        this.tableDataTreeInfo = info;
      },
      // handleCurrentChangeTreeTime(info) {},

      //点击保存按钮
      FactoryEditSave() {
        this.saveLoading = true;
        if (this.factoryDialogTitle == this.$t('btn_14')) {
          if (this.dialogFactoryEdit.name == '' || this.dialogFactoryEdit.name == null) {
            utils.messageAlert(this.$t('input_16'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.code == '' || this.dialogFactoryEdit.code == null) {
            utils.messageAlert(this.$t('input_17'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.model == '' || this.dialogFactoryEdit.model == null) {
            utils.messageAlert(this.$t('input_18'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.maker == '' || this.dialogFactoryEdit.maker == null) {
            utils.messageAlert(this.$t('input_19'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.saler == '' || this.dialogFactoryEdit.saler == null) {
            utils.messageAlert(this.$t('input_20'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.price == '' || this.dialogFactoryEdit.price == null) {
            utils.messageAlert(this.$t('input_21'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          // if (this.dialogFactoryEdit.warningInventory == '' || this.dialogFactoryEdit.warningInventory == null) {
          //   utils.messageAlert(this.$t('input_22'), this.$t('label_358'), this.$t('label_100'));
          //   this.saveLoading = false;
          //   return;
          // }
          if (this.dialogFactoryEdit.type == '' || this.dialogFactoryEdit.type == null) {
            utils.messageAlert(this.$t('input_23'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          // if (this.dialogFactoryEdit.warningTime == '' || this.dialogFactoryEdit.warningTime == null) {
          //   utils.messageAlert(this.$t('input_24'), this.$t('label_358'), this.$t('label_100'));
          //   this.saveLoading = false;
          //   return;
          // }
          if (this.dialogFactoryEdit.unit == '' || this.dialogFactoryEdit.unit == null) {
            utils.messageAlert(this.$t('input_25'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          file.saveEquipmentPartsInsert(this.dialogFactoryEdit).then((response) => {
            console.log(response)
            const data = response.data;
            if (data.code == "1") {
              this.search();
              this.$message({
                message: this.$t('msg_18'),
                type: 'success'
              });
              this.dialogFactory = false;
              this.dialogFactoryEdit = {
                code: "",
                name: "",
                maker: "",
                model: "",
                remark: "",
                price: "",
                saler: "",
                type: this.defaultType,
                unit: this.defaultUnit,
                warningInventory: "",
                warningTime: "",
              }
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.$message({
              message: this.$t('msg_77'),
              type: 'error'
            });
            this.saveLoading = false;
          })
        } else {
          if (this.dialogFactoryEdit.name == '' || this.dialogFactoryEdit.name == null) {
            utils.messageAlert(this.$t('input_16'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.code == '' || this.dialogFactoryEdit.code == null) {
            utils.messageAlert(this.$t('input_17'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.model == '' || this.dialogFactoryEdit.model == null) {
            utils.messageAlert(this.$t('input_18'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.maker == '' || this.dialogFactoryEdit.maker == null) {
            utils.messageAlert(this.$t('input_19'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.saler == '' || this.dialogFactoryEdit.saler == null) {
            utils.messageAlert(this.$t('input_20'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          if (this.dialogFactoryEdit.price == '' || this.dialogFactoryEdit.price == null) {
            utils.messageAlert(this.$t('input_21'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          // if (this.dialogFactoryEdit.warningInventory == '' || this.dialogFactoryEdit.warningInventory == null) {
          //   utils.messageAlert(this.$t('input_22'), this.$t('label_358'), this.$t('label_100'));
          //   this.saveLoading = false;
          //   return;
          // }
          if (this.dialogFactoryEdit.type == '' || this.dialogFactoryEdit.type == null) {
            utils.messageAlert(this.$t('input_23'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          // if (this.dialogFactoryEdit.warningTime == '' || this.dialogFactoryEdit.warningTime == null) {
          //   utils.messageAlert(this.$t('input_24'), this.$t('label_358'), this.$t('label_100'));
          //   this.saveLoading = false;
          //   return;
          // }
          if (this.dialogFactoryEdit.unit == '' || this.dialogFactoryEdit.unit == null) {
            utils.messageAlert(this.$t('input_25'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
            return;
          }
          file.ModifyEquipmentParts(this.dialogFactoryEdit).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.search();
              this.$message({
                message: this.$t('msg_21'),
                type: 'success'
              });
              this.dialogFactory = false;
              this.dialogFactoryEdit = {
                code: "",
                name: "",
                maker: "",
                model: "",
                remark: "",
                price: "",
                saler: "",
                type: this.defaultType,
                unit: this.defaultUnit,
                warningInventory: "",
                warningTime: "",
              }
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
          }).catch((response) => {
            console.log(response)
            this.$message({
              message: this.$t('msg_77'),
              type: 'error'
            });
            this.saveLoading = false;
          })
        }
      },
      //模糊查询
      querySearchAsync(queryString, cb) {
        let param = {
          name: queryString
        }
        file.selectEquipmentFirmList(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            cb(data.data)
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      //点击删除按钮
      factoryDel() {
        let param = this.tableDataTreeInfo.id;
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning',
          }).then(() => {
            file.delEquipmentParts(param).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.search();
                this.$message({
                  message: this.$t('msg_14'),
                  type: 'success'
                });
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          }).catch(() => {});
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      }
    },

    created() {
      this.MenuRoleList = this.$store.getters.getMenu;
      this.getPartsinformation({
        "pageNum": 1,
        "pageSize": 10,
      })
      this.getUnitdown() //单位下拉选
      this.getTypedown() //分类下拉选
      this.search()
    }

  }
</script>

<style scoped>
.el-input{
    width:200px;
  }


</style>



// WEBPACK FOOTER //
// src/pages/part/partInfo.vue